module.exports = __WEBPACK_EXTERNAL_MODULE_21__;


//////////////////
// WEBPACK FOOTER
// external "@ba/ba-graphics/dist/illustrations-js/ba-graphics-icons-commons"
// module id = 21
// module chunks = 0 2